import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { User, Timer, QrCode, Zap, X, Repeat } from "lucide-react";
import { STATUS_STYLES, remaining } from "./constants";

/**
 * One row inside the resident's active passes list. Parent passes a
 * `tickTock` prop that increments every 30s so the "1h 29m left"
 * countdown stays fresh.
 */
export function GuestPassRow({ pass, tickTock, onShowQr, onExtend, onRevoke }) {
  void tickTock; // referenced only to force a re-render every 30s
  return (
    <div className="rounded-lg border border-white/10 bg-white/[0.02] p-3 flex flex-wrap items-center gap-3 justify-between"
         data-testid={`guest-pass-${pass.id}`}>
      <div className="flex-1 min-w-[240px]">
        <div className="flex items-center gap-2 flex-wrap">
          <User className="h-3.5 w-3.5 text-zinc-500" />
          <span className="text-sm font-medium">{pass.guest_name}</span>
          <Badge variant="outline" className={STATUS_STYLES[pass.status] || ""}>{pass.status}</Badge>
          {pass.series_id && (
            <Badge variant="outline" className="border-indigo-500/30 text-indigo-300"
                   data-testid={`guest-pass-series-badge-${pass.id}`}>
              <Repeat className="h-3 w-3 mr-1" /> recurring
            </Badge>
          )}
          {pass.status === "active" && (
            <span className="text-[11px] text-zinc-500 inline-flex items-center gap-1">
              <Timer className="h-3 w-3" /> {remaining(pass.valid_until)}
            </span>
          )}
        </div>
        <div className="text-xs text-zinc-400 mt-1 font-mono">{pass.plate}</div>
        {pass.vehicle_desc && <div className="text-xs text-zinc-500">{pass.vehicle_desc}</div>}
        {pass.scan_count > 0 && (
          <div className="text-[10px] text-emerald-400 mt-0.5">
            Scanned {pass.scan_count}× at the gate
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {(pass.status === "active" || pass.status === "pending") && (
          <>
            <Button size="sm" variant="outline"
                    className="border-emerald-500/30 text-emerald-300 hover:bg-emerald-500/10"
                    onClick={() => onExtend(pass.id)}
                    data-testid={`guest-pass-extend-${pass.id}`}
                    title="Extend by 24 hours">
              <Zap className="h-3.5 w-3.5 mr-1" /> +24h
            </Button>
            <Button size="sm" variant="outline" className="border-white/10"
                    onClick={() => onShowQr(pass)}
                    data-testid={`guest-pass-qr-${pass.id}`}>
              <QrCode className="h-3.5 w-3.5 mr-1" /> Show QR
            </Button>
            <Button size="sm" variant="outline"
                    className="border-red-500/30 text-red-300 hover:bg-red-500/10"
                    onClick={() => onRevoke(pass.id)}
                    data-testid={`guest-pass-revoke-${pass.id}`}>
              <X className="h-3.5 w-3.5" />
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
